export const ethiopiaElementsProgram = {
  programKey: 'etiopia-zycie-poludnia-i-gory-bale',

  /* Podstawowe informacje wspólne dla sticky paska i katalogu. */
  title: 'Etiopia - Życie południa i góry Bale',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Etiopia:',
  stickySubtitle: 'Życie południa i góry Bale',

  pageUrl:
    'https://coolturystki.pl/wycieczki/etiopia-zycie-poludnia-i-gory-bale',

  catalog: {
    enabled: true,
    image:
      'https://coolturystki.pl/lib/wyfaqa/coolturystki-etiopia-droga-krajobraz-mvi55tdk.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/coolturystki-etiopia-droga-krajobraz-mvi55tdk.webp',
    imagePosition: 'center top',
    summary: '',
    destinations: ['Etiopia'],
    continent: 'Afryka',
    categories: [],
    travelStyles: ['Wyjazd objazdowy', 'Egzotyka'],
    catalogPublishedAt: '2026-09-11',
  },

  /* Terminy: 31 stycznia - 15 lutego oraz 26 września - 11 października 2027. */
  tripIds: [17, 35],

  /*
   * Brak priceNote oznacza, że karta automatycznie pokaże pierwszą transzę
   * obliczoną jako 30% aktualnej ceny pobranej z Vakanzy.
   */
  termDetails: {
    '17': {
      pilotId: 'dorota',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Lot grupowy z Warszawy',
          description:
            'Z Warszawy lecimy bezpośrednio do Addis Abeby, a wracamy z Arba Mincz do Warszawy przez Addis Abebę. Możliwy jest także wylot z Berlina; powrót odbywa się wspólnie do Warszawy.',
        },
        hotel: {
          title: 'Hotele i lodge’e 3★ i 4★ na trasie',
          description:
            'Na trasie nocujemy w pokojach 2-osobowych w hotelach i lodge’ach 3★ i 4★. Cena obejmuje śniadania, lunche, obiadokolacje oraz butelkowaną wodę przez cały pobyt.',
        },
      },
    },

    '35': {
      pilotId: 'dorota',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Lot grupowy z Warszawy',
          description:
            'Z Warszawy lecimy bezpośrednio do Addis Abeby, a wracamy z Arba Mincz do Warszawy przez Addis Abebę. Możliwy jest także wylot z Berlina; powrót odbywa się wspólnie do Warszawy.',
        },
        hotel: {
          title: 'Hotele i lodge’e 3★ i 4★ na trasie',
          description:
            'Na trasie nocujemy w pokojach 2-osobowych w hotelach i lodge’ach 3★ i 4★. Cena obejmuje śniadania, lunche, obiadokolacje oraz butelkowaną wodę przez cały pobyt.',
        },
      },
    },
  },
}
